<div class="coupon">
  <app-svg src="/assets/icons/discount.svg"></app-svg>
  <div class="coupon-content">
    <b class="coupon-title">{{ promotion().name }}</b>
    <div class="coupon-meta">
      @if (promotion().duration === 'forever') {
        <span>Lifetime Discount</span>
      } @else if (promotion().duration === 'repeating') {
        <span>Applies for the first {{ promotion().duration_in_months }} months</span>
      } @else if (promotion().duration === 'once') {
        <span>Applies to the first payment</span>
      }
      <app-context-menu
        [options]="{ width: '250px', doubleSpacing: true, openOnHover: true }"
        verticalPosition="top"
        position="center"
        name="pricing-details"
      >
        <button
          type="button"
          appButton
          name="pricing-details"
          location="checkout-coupon"
          height="-2"
          [iconButton]="true"
          color="hard-simple"
          contextButton
        >
          <app-svg src="/assets/icons/16/info.svg" size="-1-5"></app-svg>
        </button>
        <div contextContent>
          <app-promo-details [promo]="promotion()"></app-promo-details>
        </div>
      </app-context-menu>
    </div>
  </div>
</div>
